//const fds=
const api_host=process.env.REACT_APP_API

export const saveTemplateAdd = (user, token, name, desc, upload, code) => 
fetch(api_host+`/reporte/general/Template/`,
  {
    method:'POST',
    body:JSON.stringify({
      "name": name,
      "upload":upload,
      "code":code,
      "desc": desc,
      "user": user,
      "token": token,
    }),
    headers: {
      "Content-Type": "application/json",
    },
  }
).then(response => response.json())

export const updateTemplate = (id, user, token, name, desc, upload, code) => 
fetch(api_host+`/reporte/general/Template/`,
  {
    method:'PATCH',
    body:JSON.stringify({
      "id": id,
      "name": name,
      "upload":upload,
      "code":code,
      "desc": desc,
      "user": user,
      "token": token,
    }),
    headers: {
      "Content-Type": "application/json",
    },
  }
).then(response => response.json())

export const templateView = (user, token) => 
fetch(api_host+`/reporte/general/Template/?user=${user}&token=${token}&method=view&start=${new Date().getTime()}`)
.then(response => response.json())

export const templateDelete= (user, token, id) => 
fetch(api_host+`/reporte/general/Template/?user=${user}&token=${token}&method=delete&id=${id}`)
.then(response => response.json())